import "../styles/Header.scss";
import titleimg from "../assets/titleimg.png";
import Slide from "react-reveal/Slide";
import AnchorLink from "react-anchor-link-smooth-scroll-ts";



const Header = () => {
  return (
    <div className="header">
      {/*<div className="music">
        <ReactAudioPlayer src={music} autoPlay controls className="player"/>
        
  </div>*/}
   <div className="music">
        <Slide left>
          {/*<img src={tape} alt="tape" className="tape" title="tape" />
          <AudioPlayer autoPlay className="player" src={music} onPlay={e => console.log("onPlay") }/>*/}
        </Slide>
    </div>
      <section id="sectionHeader"></section>
      <Slide top>         <img src={titleimg} alt="titleimg" className="titleimg"></img>      </Slide>
      <ul className="text"> 
        <li> <AnchorLink href="#sectionWebdesign"> <p>Webdesign</p> </AnchorLink> </li> 
        <li> <AnchorLink href="#sectionCreation"> <p>Creations</p> </AnchorLink> </li>
        <li> <AnchorLink href="#sectionLogo"> <p>Logos</p> </AnchorLink> </li>
        <li> <AnchorLink href="#sectionContact"> <p>Contact</p> </AnchorLink> </li>
      </ul>
    </div>
  );
};

export default Header;
